import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setFilters } from '../../redux/inboxSlice';
import InboxPage from '../inbox/InboxPage';

// Telegram messages already flow through the same generic Conversation/
// InboxMessage models as WhatsApp/Instagram (channel: 'telegram') — no
// separate messaging UI needed, just pre-filter the existing unified inbox.
export default function TelegramMessagesTab() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setFilters({ channel: 'telegram' }));
  }, [dispatch]);

  return <InboxPage />;
}
